import {Resolver, yupResolver} from '@hookform/resolvers/yup';

// yupResolver wrapper with predefined resolverOptions = {rawValues: true} to avoid form value/type transformation by yupSchema validation
const resolver: Resolver = (schema, schemaOptions = {}, resolverOptions = {rawValues: true}) =>
    yupResolver(schema, schemaOptions, resolverOptions);

export {resolver};
